export default __webpack_public_path__ + "pgnv-assets/2c4584f87585c66b43c0fd6f127b22f6.png";